export const NIL_UUID = '00000000-0000-0000-0000-000000000000';

export function isNilUuid(value: string | null | undefined): boolean {
  const normalized = value?.trim().toLowerCase() || '';
  return normalized === NIL_UUID;
}

export function normalizeNilUuid(value: string | null | undefined): string | null {
  const normalized = value?.trim() || '';
  if (normalized === '' || isNilUuid(normalized)) {
    return null;
  }
  return normalized;
}
